import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { authenticationActions } from 'srcReact/redux/actions/authentication'
import { withTranslation, useTranslation } from 'react-i18next'
import config from 'config'

import Button from 'srcReact/components/common2/Button'
import Checkbox from 'srcReact/components/common2/Checkbox'
import { TextBox } from 'srcReact/components/common2/TextBox'
import { isEmail, isEmpty } from 'srcReact/helpers/validator'
import Spinner from 'srcReact/components/common2/Spinner'
import styles from './styles.module.scss'
import history, { redirectToPage } from 'srcReact/helpers/history'
import queryString from 'query-string'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import { getCookie } from 'srcReact/helpers/utils'

const Email = ({
  checkEmailIfValid,
  sendActivationCode,
  checkEmailLoading,
  checkEmailAlreadyUsed,
  checkEmailError,
  workplace_invitations,
  organizations,
  checkEmail,
  updateStep,
  previousStep,
  setPreviousStep,
  formState,
  setFormState,
  isNative
}) => {
  const { t } = useTranslation()

  const [email, setEmail] = useState({
    name: 'email',
    value: formState.email,
    hasError: false,
    errorMessage: '',
    isRequired: true
  })

  const [showEmailField, setShowEmailField] = useState(true)

  const [emailConfirmation, setEmailConfirmation] = useState({
    name: 'emailConfirmation',
    value: formState.confirmEmail,
    hasError: false,
    errorMessage: '',
    isRequired: true
  })

  const [serverError, setServerError] = useState('')

  const [agreeMixrTerms, setAgreeMixrTerms] = useState(formState.agreeMixrTerms)
  const [errorAgree, setErrorAgree] = useState(false)
  const [emailChecked, setEmailChecked] = useState(false)

  const handleSendActivationCode = (value) => {
    setFormState({ ...formState, codeConfirmationEmail: '' })
    sendActivationCode(value)
  }

  useEffect(() => {
    /* New user invited by email to join a workplace */
    const serverAccessToken = getCookie('saccess_token')
    if (history.location.state) {
      const { queryParam } = history.location.state
      const match = queryParam?.match(/email=([^&]+).*?step=([^&]+)/)
      if (match && match[1] && match[2] === 'workplace-invitation') {
        setTimeout(
          () => {
            const email = match[1]
            setEmail({ ...email, value: email })
            setEmailConfirmation({ ...emailConfirmation, value: email })
            setFormState({
              ...formState,
              email: email,
              confirmEmail: email,
              skipConfirmationEmail: true
            })
            checkEmailIfValid(email)
            setEmailChecked(true)
            history.replace({ ...history.location, state: null })
          },
          serverAccessToken ? 0 : 2500
        )
      }
    }
  }, [])
  useEffect(() => {
    //checkEmail object is used when user registers using /0/signup
    //login object from reducer is used when user registers using /auth
    if (emailChecked && !checkEmailLoading) {
      if (checkEmail && checkEmail.is_registered === 1) {
        redirectToPage('/auth')
      } else {
        setPreviousStep([...previousStep, 'email'])
        updateStep(
          formState.skipConfirmationEmail || checkEmail?.workplace_invitations?.length > 0
            ? 'invitation'
            : 'confirmEmail'
        )
        //show veryfy email step only if there is no workplace invitation
        if (checkEmail?.workplace_invitations?.length === 0) {
          handleSendActivationCode(email.value)
        }

        setFormState({
          ...formState,
          email: email.value,
          confirmEmail: emailConfirmation.value,
          agreeMixrTerms,
          organizations: checkEmail && checkEmail.is_registered === 0 ? checkEmail.organizations : organizations,
          workplace_invitations:
            checkEmail && checkEmail.is_registered === 0 ? checkEmail.workplace_invitations : workplace_invitations,
          workplaceInvitationsSelected:
            checkEmail && checkEmail.is_registered === 0
              ? checkEmail.workplace_invitations?.map((invite) => invite.id)?.toString()
              : workplace_invitations?.map((invite) => invite.id)?.toString()
        })
      }
    }
  }, [emailChecked, checkEmailLoading, checkEmail])

  useEffect(() => {
    let queryStringObj = queryString.parse(location.search)
    if (queryStringObj && queryStringObj.step) {
      setShowEmailField(false)
    }
  }, [])

  useEffect(() => {
    if (formState.fromSuccessStep) {
      setShowEmailField(true)
    }
  }, [formState.fromSuccessStep])

  useEffect(() => {
    if (checkEmail && checkEmail.is_registered === 1) {
      setEmail({ ...email, hasError: true, errorMessage: t('signup.email_module.error_msg_1') })
    }
  }, [checkEmail])
  useEffect(() => {
    if (checkEmailError) {
      setServerError(checkEmailError.message)
    } else {
      setServerError('')
    }
  }, [checkEmailError])
  const handleChangeEmail = (e) => {
    if (e && e.target) {
      const { value } = e.target
      setEmail({
        ...email,
        value: value
      })
    }
  }
  const handleBlurEmail = (e) => {
    if (e && e.target) {
      const { name, value } = e.target
      validateEmail()
    }
  }

  const validateEmail = () => {
    if (email.isRequired && isEmpty(email.value)) {
      setEmail({
        ...email,
        hasError: true,
        errorMessage: t('signup.email_module.error_msg_2')
      })
      return false
    }
    if (!isEmail(email.value)) {
      setEmail({
        ...email,
        hasError: true,
        errorMessage: t('signup.email_module.error_msg_3')
      })
      return false
    }

    setEmail({
      ...email,
      hasError: false,
      errorMessage: ''
    })

    return true
  }

  const handleChangeEmailConfirmation = (e) => {
    if (e && e.target) {
      const { value } = e.target
      setEmailConfirmation({
        ...emailConfirmation,
        value: value
      })
    }
  }

  const handleBlurEmailConfirmation = (e) => {
    if (e && e.target) {
      const { name, value } = e.target
      validateEmailConfirmation()
    }
  }

  const validateEmailConfirmation = () => {
    if (emailConfirmation.isRequired && isEmpty(emailConfirmation.value)) {
      setEmailConfirmation({
        ...emailConfirmation,
        hasError: true,
        errorMessage: t('signup.email_module.error_msg_4')
      })
      return false
    }
    if (emailConfirmation.value.toLowerCase() !== email.value.toLowerCase()) {
      setEmailConfirmation({
        ...emailConfirmation,
        hasError: true,
        errorMessage: t('signup.email_module.error_msg_5')
      })
      return false
    }

    setEmailConfirmation({
      ...emailConfirmation,
      hasError: false,
      errorMessage: ''
    })

    return true
  }

  const validateTerms = () => {
    if (!agreeMixrTerms) {
      setErrorAgree(true)
      return false
    }
    return true
  }

  return (
    <div className={styles.container}>
      <div className={styles.container1}>
        <div className={styles.textBoxContainer}>
          {showEmailField && (
            <TextBox
              label={t('signup.email_module.email')}
              customWrapperCss={styles.textBoxCSS}
              customInputCss={styles.textBoxInputCSS}
              fieldInfo={email}
              onChange={handleChangeEmail}
              onBlur={handleBlurEmail}
              placeholder={t('signup.email_module.email')}
            />
          )}

          <TextBox
            label={t('signup.email_module.retype_email')}
            customWrapperCss={styles.textBoxCSS}
            customInputCss={styles.textBoxInputCSS}
            fieldInfo={emailConfirmation}
            onChange={handleChangeEmailConfirmation}
            onBlur={handleBlurEmailConfirmation}
            placeholder={t('signup.email_module.retype_email')}
          />
        </div>
        <div className={styles.agree}>
          <Checkbox
            customClassName={styles.checkBoxAgree}
            checked={agreeMixrTerms}
            onChange={(e) => {
              setAgreeMixrTerms(e.target.checked)
              setErrorAgree(false)
            }}
          />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div className={styles.agreeTextContainer}>
              {t('signup.email_module.agree')}{' '}
              <a className={styles.terms} href={config.webUrl + '/terms-of-services'} target='_blank'>
                {t('signup.email_module.term')}
              </a>{' '}
              {t('global.and')}{' '}
              <a className={styles.terms} href={config.webUrl + '/privacy-policy'} target='_blank'>
                {t('signup.email_module.privacy')}
              </a>
            </div>
            {checkEmailLoading && <Spinner />}

            {serverError && <div className={styles.errorTerms}>{serverError}</div>}
          </div>
        </div>
        {errorAgree && <ErrorMessage text={t('signup.email_module.agree_terms')} className={styles.errorTerms} />}
      </div>
      <div className={styles.buttonContainer}>
        <Button
          text={t('global.back')}
          size='large'
          style='secondary'
          handleClick={() => {
            redirectToPage('/auth?from=signup', isNative)
          }}
        />
        <Button
          text={t('signup.email_module.confirm')}
          size='large'
          customStyle={styles.confirmButton}
          disabled={checkEmailLoading}
          handleClick={() => {
            if (validateEmail() && validateEmailConfirmation() && validateTerms()) {
              if (showEmailField) {
                checkEmailIfValid(email.value)
              }
              setEmailChecked(true)
            }
          }}
        />
      </div>
    </div>
  )
}

function mapStateToProps(state) {
  const {
    common: { isNative },
    login: { workplace_invitations, organizations },
    authentication: { checkEmail, checkEmailLoading, checkEmailAlreadyUsed, checkEmailError }
  } = state

  return {
    checkEmailLoading,
    checkEmailAlreadyUsed,
    checkEmailError,
    workplace_invitations,
    organizations,
    isNative,
    checkEmail
  }
}

const actionCreators = {
  checkEmailIfValid: authenticationActions.checkEmail,
  sendActivationCode: authenticationActions.sendActivationCode
}

const ExtendedComponent = withTranslation('common')(Email)

const connectedEmail = connect(mapStateToProps, actionCreators)(ExtendedComponent)
export { connectedEmail as Email }
